document.addEventListener("DOMContentLoaded", function () {
    console.log("Custom underline script loaded!");

    const elements = document.querySelectorAll(".panel-usage-block, .section-title, .contact-hero h1, .contact-cards h2, .faq-title");

    if (elements.length === 0) {
        console.warn("No elements found for underlining effect.");
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry, index) => {
            if (entry.isIntersecting) {
                console.log("Element visible, adding fade-in:", entry.target);

                // Pridanie oneskorenia pre plynulejší efekt
                setTimeout(() => {
                    entry.target.classList.add("fade-in");
                }, index * 200);

                observer.unobserve(entry.target); // Odstráni pozorovanie po aktivácii
            }
        });
    }, { threshold: 0.3 });

    elements.forEach((el) => {
        console.log("Observing element:", el);
        observer.observe(el);
    });
});